import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'


import en from 'web/locales/en.json'
import ptBR from 'web/locales/pt-BR.json'

const resources = {
  en: { translation: en },
  'pt-BR': { translation: ptBR },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt-BR',
    fallbackLng: 'pt-BR',
    supportedLngs: ['pt-BR', 'en'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'predita-lang',
      caches: ['localStorage'],
    },
  })

export default i18n
